import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=a546f292"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports